import SignalFolderCard from "../../components/signal/SignalFolderCard";
import { SIGNAL_FOLDERS } from "../../interfaces/signalFolder";
import { SignalIcon } from "@heroicons/react/24/solid";
import { PageHeader } from "../../components/ui/PageHeader";

// Purely static page: the folder grid comes from SIGNAL_FOLDERS and renders instantly.
// (It used to block on /establishments/stats/by-signal-type to compute per-folder counts,
// but SignalFolderCard never displays a count — the fetch only delayed the render.)
export default function Signals() {
    return (
        <div className="min-h-screen bg-canvas font-sans">
            <div className="mx-auto max-w-7xl px-4 md:px-8 pb-6">
                <PageHeader icon={<SignalIcon />} title="Signaux" subtitle="Identification automatique d'opportunités commerciales" />

                {/* Every folder on one screen: 4 × 2 on a laptop, compact cards */}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {SIGNAL_FOLDERS.map(folder => (
                        <SignalFolderCard key={folder.id} folder={folder} />
                    ))}
                </div>
            </div>
        </div>
    );
}
